module.exports = __webpack_public_path__ + "img/Step2.eb34216.svg";